var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodayActiveProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_px",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-11c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m.77 15c-.229 0-.435-.158-.487-.39-.188-.832-.283-1.71-.283-2.61 0-6.617 5.383-12 12-12 3.754 0 7.22 1.711 9.507 4.696.168.219.126.533-.093.701-.22.168-.532.126-.701-.093-2.096-2.735-5.272-4.304-8.713-4.304-6.065 0-11 4.935-11 11 0 .827.087 1.631.258 2.39.061.27-.108.537-.378.598-.037.008-.074.012-.11.012z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 24c-3.754 0-7.22-1.711-9.507-4.696-.168-.219-.126-.533.093-.701.22-.167.533-.125.701.093 2.096 2.735 5.272 4.304 8.713 4.304 6.065 0 11-4.935 11-11 0-.838-.089-1.641-.266-2.384-.064-.269.102-.539.371-.602.271-.065.539.102.602.371.194.819.293 1.699.293 2.615 0 6.617-5.383 12-12 12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2.55 24c-.274 0-.497-.221-.5-.495l-.05-5c-.001-.133.051-.262.145-.356.094-.096.222-.149.355-.149h5c.276 0 .5.224.5.5s-.224.5-.5.5h-4.495l.045 4.495c.003.276-.218.502-.495.505-.001 0-.003 0-.005 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 6h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4.5v-4.5c0-.276.224-.5.5-.5s.5.224.5.5v5c0 .276-.224.5-.5.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11 14.5c-.132 0-.26-.053-.354-.146l-1.75-1.75c-.195-.195-.195-.512 0-.707s.512-.195.707 0l1.37 1.37 2.898-3.344c.182-.208.497-.231.706-.05.208.181.231.497.05.706l-3.25 3.75c-.091.104-.221.167-.36.172-.005-.001-.011-.001-.017-.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayActiveProduct);
export default __webpack_public_path__ + "static/media/todayActiveProduct.7f79ac302a10497096cdd334b21c80cf.svg";
export { ForwardRef as ReactComponent };